import { NavigationGuard } from 'vue-router';
import { RouteNames } from '@/routes';

import { Cache } from '@/common/cache';

export const adminGuard: NavigationGuard = async (to, from, next) => {
    try {

        const isAdmin = Cache.instance.isAdmin.value;
        if (!isAdmin) {
            return next({ name: RouteNames.facilities });
        }
        return next();
    } catch (error: any) {
        return next({ replace: true, name: RouteNames.error, params: { title: 'Navigation error', error, to: to.fullPath } });
    }
};